import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface MirroredActivityMessageBarProps {
  childActivityCount: number;
}

export const ActivityWithMirroredChildrenMessageBar = (
  props: MirroredActivityMessageBarProps
) => {
  const { childActivityCount } = props;

  const { t } = useTranslation();

  if (!childActivityCount) {
    return <></>;
  }

  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>{t("note")}</MessageBarTitle>
        {t("activityWithMirroredChildrenWarningMessage", {
          count: childActivityCount,
        })}
      </MessageBarBody>
    </MessageBar>
  );
};
